import { Thunder } from '@goodlok/sdk/generated/content_role_admin'
import { Thunder as ShiftsManagerThunder } from '@goodlok/sdk/generated/content_role_shifts_manager'
import { fromThunder } from '@goodlok/sdk/zeus/fromThunder'

export const thunder = {
	admin: fromThunder(Thunder, { url: `${process.env.BACKEND_URL}/content` }),
	shiftsManager: fromThunder(ShiftsManagerThunder, { url: `${process.env.BACKEND_URL}/content` }),
}
